export function formatFbclid (fbclid = '') {
  if (!fbclid) {
    return null
  }

  const cleanFbclid = String(fbclid).trim()

  if (/^fb\.1\.\d+\./i.test(cleanFbclid)) {
    return cleanFbclid
  }

  const timestamp = Date.now()

  return `fb.1.${timestamp}.${cleanFbclid}`
}

export function compareFbclid (unformattedFbclid, formattedFbclid) {
  if (!unformattedFbclid || !formattedFbclid) {
    return false
  }

  const cleanUnformatted = String(unformattedFbclid).trim()

  const formattedValue = formattedFbclid.split('.').pop()

  return cleanUnformatted === formattedValue
}
